import {createElement, Component, PropTypes} from 'rlink-react';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import {connect} from 'react-redux';

import ScrollTo from 'rlink-scrolling/ScrollTo.jsx';
import getCurrentRouteState from 'rlink-router/getCurrentRouteState';

function RoutingTransitions ({
  contentTransition,
  children,
  view,
  transitionTimeout,
  params,
  scrollPosition,
}) {
  let scrollContainer = <div key={`${view}`}>
    <ScrollTo top={scrollPosition.top} left={scrollPosition.left} />
    {children}
  </div>;

  if (contentTransition) {
    return <CSSTransitionGroup
      transitionName={contentTransition}
      transitionEnterTimeout={transitionTimeout}
      transitionLeaveTimeout={transitionTimeout}>
      <div key={`${view}${JSON.stringify(params)}`}>{scrollContainer}</div>
    </CSSTransitionGroup>;
  } else {
    return scrollContainer;
  }
}

RoutingTransitions.propTypes = {
  contentTransition: PropTypes.string,
  transitionTimeout: PropTypes.number,
  view: PropTypes.string,
  params: PropTypes.object,
  scrollPosition: PropTypes.shape({
    top: PropTypes.number,
    bottom: PropTypes.number,
  }),
  children: PropTypes.node,
};

RoutingTransitions.defaultProps = {
  transitionTimeout: 250,
  scrollPosition: {top: 0, left: 0},
};

export default connect(
  ({routing}) => {
    let {
      view,
      params = {},
      transition,
      scrollPosition,
    } = getCurrentRouteState(routing);
    return {
      contentTransition: transition,
      view, params, scrollPosition,
    };
  }
)(RoutingTransitions);



// WEBPACK FOOTER //
// ./lib/rlink-router/RoutingTransitions.jsx